import './includes/fixOldBrowsers';
import 'babel-polyfill';
import Inputmask from "inputmask/dist/inputmask/inputmask.date.extensions";
import vRate from './includes/vRate.js';
import handlePopup from './includes/popupForm.js';
import handleFileInputsChange from './includes/handleFileInp.js';
import './includes/customSelects.js';
import './includes/handleContactsPopup.js';
import './includes/menu.js';
import './includes/showBaners';
import vanillaTextMask from 'vanilla-text-mask';
import { v$ } from './includes/helpers.js';
import './includes/tipTriger';
import 'scss/style.scss'
//Cal functions
vRate('blago_rate',{
	generateInp:false,
	inpId:'reviewform-rate',
	defaultRate:4
});

//Handle popup feedback
handlePopup(v$('#feedback')[0],v$('#feedback_open')[0]);
handlePopup(v$('#feedback')[0],v$('#feedback_open_mob')[0]);
if(v$('.js-write').length > 0){
    handlePopup(v$('#feedback')[0],v$('.js-write')[0]);
    handlePopup(v$('#feedback')[0],v$('.js-write')[1]);
}
//Handle popup review
handlePopup(v$('#review')[0],v$('#review_open')[0]);
handlePopup(v$('#review')[0],v$('#review_open_mob')[0]);
//Handle popup callRequest
handlePopup(v$('#callRequest')[0],v$('#call_request_open')[0]);
handlePopup(v$('#callRequest')[0],v$('#call_request_open_mob')[0]);


//Close thx popup
handlePopup(v$('#thx')[0],false);



// handle fileInp change
handleFileInputsChange();


//only numbers input
let NumberInputs = v$('[type="tel"]');


NumberInputs.forEach( (item)=> {
	item.addEventListener('keydown',(e) => {
		const reg = /^\d+$/;
		if( (!reg.test(e.key)) && !['Backspace','Tab','ArrowLeft','ArrowRight','Delete', '.'].includes(e.key)){
			e.preventDefault();
		}
	});
	item.addEventListener('paste',(e) => {
		e.preventDefault();
	});
});

//mask tel inputs

const telMask = ['+','3','8', '0','(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

let tel = v$('input[data-tel]');

let im = new Inputmask('+38(099)999-9999');

tel.forEach(item => {
	im.mask(item);
});

/*25.02.2019*/
$('#double-price-gold-btn').on('click', function(e) {
  e.preventDefault();
  $('#double').addClass('active');
});

$('#double .popup-close').on('click', function(e) {
  e.preventDefault();
  $('#double').removeClass('active');
});

$('#thanks .popup-close').on('click', function(e) {
  e.preventDefault();
  $('#thanks').removeClass('active');
});
/* end 25.02.2019 */

/*add header store button dropdown*/
$('.login-btn').on('click', function(e) {
  if(e.target.className != "goBack") {
    $('.login-btn .login-btn-title').not(e.target === '.goBack').toggleClass('open');
    $('.login-btn .dropdown').toggleClass('open');
  }

});

$('.goBackBtn').on('click', function() {
  $('.login-btn .login-btn-title').removeClass('open');
  $('.login-btn .dropdown').removeClass('open');
});
/*end add header store button dropdown*/

/*22.06.2019*/
var allVideos = $("iframe[src*='//player.video.com'], " +
  "iframe[src*='//www.youtube.com'], " +
  "iframe[src*='//www.youtube-nocookie.com'], object, embed");
var newWidth;
var el;

allVideos.each(function() {
  $(this).attr("data-aspectRatio", this.height / this.width)
    .removeAttr("height").removeAttr("width");
});

$(window).resize(function() {
  allVideos.each(function() {
    el = $(this);
    newWidth = el.parent().width();
    el.width(newWidth).height(newWidth * el.attr("data-aspectRatio"));
  });
}).resize();

export const loadMapData = function ($callBack) {
  $.ajax({
    url: '/api/data/map-widget',
    success: (data) => {
      for (let i in data) {
        window[i] = data[i];
      }
      if(typeof($callBack) === "function"){
        $callBack();
      }
    }
  })
}
// Login-btn hint
{
  window.addEventListener('scroll', hideLoginHint)
  window.addEventListener('click', hideLoginHint)

  function hideLoginHint() {
    const hintElement = document.getElementById('login-btn-hint');
    if(hintElement) {
      hintElement.style.display = 'none';

      window.removeEventListener('scroll', hideLoginHint)
      window.removeEventListener('click', hideLoginHint)
    }
  }
}

// accessibility-panel
const accessibilitySettings = () => {
  const html = document.documentElement;
  const panel = document.getElementById('accessibility-panel');
  const accessibilityToggleBtn = document.querySelector('.accessibility-panel__toggle-button')
  const increaseBtn = document.getElementById("increase-font");
  const decreaseBtn = document.getElementById("decrease-font");
  let step = parseInt(localStorage.getItem('fontSizeStep')) || 0;
  const maxStep = 4
  const minStep = 1

  // if(step <= 0) {
  //   decreaseBtn.classList.add('is-disabled')
  // } else {
  //   decreaseBtn.classList.remove('is-disabled')
  // }
  //
  // if(step >= maxStep) {
  //   increaseBtn.classList.add('is-disabled')
  // } else {
  //   increaseBtn.classList.remove('is-disabled')
  // }
  function updateAccessibilityFontSize() {
    for (let i = minStep; i <= maxStep; i++) {
      html.classList.remove(`large-${i}`);
    }
    html.classList.add(`large-${step}`);
    localStorage.setItem('fontSizeStep', step);
  }
  function resetAccessibilityFontSize() {
    html.classList.remove('accessibility-size')
    html.classList.remove(`large-${step}`);
    step = 0
    localStorage.removeItem('fontSizeStep');
  }

  function resetContrast() {
    html.classList.remove('contrast-straight', 'contrast-backward');
    localStorage.removeItem('contrastMode');
  }

  increaseBtn.addEventListener("click", () => {
    html.classList.add('accessibility-size')
    if (step < maxStep) {
      step++;
      updateAccessibilityFontSize();
    }
  });

  decreaseBtn.addEventListener("click", () => {
   if (step > minStep) {
      step--;
      updateAccessibilityFontSize();
    } else {
     resetAccessibilityFontSize()
    }
  });

  document.querySelector('.accessibility-panel__toggle-button').addEventListener('click', event => {
    const _this = event.target;

    if (_this.classList.contains('is-active')) {
      _this.classList.remove('is-active');
      panel.classList.remove('accessibility-panel-opened');
      html.classList.remove('is-accessibility-active');
      localStorage.removeItem('accessibilityPanel');

      setTimeout(() => {
        panel.style.transition = 'height 0.25s ease-out';
        panel.style.height = '0px';

        setTimeout(() => {
          panel.style.display = 'none';
        }, 250);
      }, 0);
    } else {
      panel.style.display = 'block';
      panel.style.height = 'auto';
      let fullHeight = panel.offsetHeight + 'px';
      panel.style.height = '0px';

      setTimeout(() => {
        panel.style.transition = 'height 0.25s ease-in';
        panel.style.height = fullHeight;
      }, 0);

      setTimeout(() => {
        _this.classList.add('is-active');
        panel.classList.add('accessibility-panel-opened');
        html.classList.add('is-accessibility-active');
        localStorage.setItem('accessibilityPanel', true);
      }, 100);
    }
  });

  document.querySelector('#accessibility-close').addEventListener('click', () => {
    accessibilityToggleBtn.classList.remove('is-active');
    panel.classList.remove('accessibility-panel-opened');
    html.classList.remove('is-accessibility-active');
    localStorage.removeItem('accessibilityPanel');
    setTimeout(() => {
      panel.style.transition = 'height 0.25s ease-out';
      panel.style.height = '0px';

      setTimeout(() => {
        panel.style.display = 'none';
      }, 250);
    }, 100);
  })

  document.querySelector('#contrast-straight').addEventListener('click', () => {
    html.classList.add('contrast-straight');
    localStorage.setItem('contrastMode', 'contrast-straight');

    if (html.classList.contains('contrast-backward')) {
      html.classList.remove('contrast-backward');
    }
  })

  document.querySelector('#contrast-backward').addEventListener('click', () => {
    html.classList.add('contrast-backward');
    localStorage.setItem('contrastMode', 'contrast-backward');

    if (html.classList.contains('contrast-straight')) {
      html.classList.remove('contrast-straight');
    }
  })

  document.querySelector('#accessibility-reset').addEventListener('click', () => {
    resetAccessibilityFontSize()
    resetContrast()
  })

  function restoreSettings() {
    if (step > 0) {
      html.classList.add('accessibility-size');
      updateAccessibilityFontSize();
    }

    const savedContrast = localStorage.getItem('contrastMode');
    const accessibilityPanel = localStorage.getItem('accessibilityPanel')
    if (savedContrast) {
      html.classList.add(savedContrast);
    }

    if(accessibilityPanel) {
      html.classList.add('is-accessibility-active');
      document.querySelector('.accessibility-panel__toggle-button').classList.add('is-active');
      if(panel) {
        panel.classList.add('accessibility-panel-opened');
        panel.style.display = 'block';
        panel.style.height = 'auto';
        let fullHeight = panel.offsetHeight + 'px';
        panel.style.height = '0px';

        setTimeout(() => {
          panel.style.transition = 'height 0.25s ease-in';
          panel.style.height = fullHeight;
        }, 0);
      }
    }
  }

  restoreSettings();
}

accessibilitySettings();






// END Login-btn hint

